export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="11" fill="#0A0D12" stroke="rgba(245,158,11,0.4)" />
    <path
      d="M10 20.5 L24 9.5 L38 20.5"
      stroke="#FFFFFF"
      strokeWidth="3.4"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 20 V28 M35 20 V28"
      stroke="#FFFFFF"
      strokeWidth="3.4"
      strokeLinecap="round"
    />
    <path
      d="M26.2 15.5 L17.5 28 L23.6 28 L21 34.5 L30.5 22.5 L24.4 22.5 Z"
      fill="#F59E0B"
    />
  </svg>
);

export const Wordmark = ({ compact = false }) => (
  <span className="flex items-baseline gap-1.5 font-display font-extrabold tracking-tight leading-none">
    <span className="text-zinc-100 text-lg sm:text-xl">FIX&nbsp;ROMA</span>
    <span className="rounded-md bg-amber-400 px-1.5 py-0.5 text-[11px] sm:text-xs font-tech font-semibold text-zinc-950">
      H24
    </span>
    {!compact && (
      <span className="hidden sm:block ml-2 font-tech text-[10px] font-medium uppercase tracking-[0.25em] text-zinc-500">
        Pronto intervento
      </span>
    )}
  </span>
);
